import React from 'react';
import { convertToDate } from "examsbook-react-sdk/common";

/**
 * Bullet points of a quiz card.
 * @param props
 * @returns {*}
 * @constructor
 */
const QuizDetails = props => {
    const { quizData, t } = props;
    return (
        <div className="card-details test-details">
            <ul>
                <li>{quizData && quizData.totalQuestions ? quizData && quizData.totalQuestions : quizData && quizData.total ? quizData && quizData.total : 0} {t('questions')}</li>
                <li>{quizData && quizData.duration} {t('minutes')}</li>
                <li>{quizData && quizData.quizMark ? ( quizData && quizData.quizMark ) : quizData && quizData.mark ? (quizData && quizData.mark).toFixed(2) : '0'} {t('marks')}</li>
                <div className="date-time"> {
                    quizData && quizData.endDate ?
                        <li>{t('expires_on')} : {convertToDate(quizData && quizData.endDate)} </li> : <span></span>
                }
                </div>
            </ul>
        </div>
    );
};

export default QuizDetails;
